"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _reactIntl = require("react-intl");

var _togaButton = _interopRequireDefault(require("@thinkific/toga-button"));

var _Datatable = _interopRequireDefault(require("../Datatable.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var cx = _bind["default"].bind(_Datatable["default"]);

var SelectionIndicator = function SelectionIndicator(_ref) {
  var clearSelectionCallback = _ref.clearSelectionCallback,
      isAllDatasetSelected = _ref.isAllDatasetSelected,
      selectedIds = _ref.selectedIds,
      pageSize = _ref.pageSize,
      selectAllDatasetCallback = _ref.selectAllDatasetCallback,
      recordType = _ref.recordType,
      totalRecords = _ref.totalRecords;
  var content;

  if (isAllDatasetSelected || totalRecords === selectedIds.length) {
    // All records in the dataset are selected message
    content = /*#__PURE__*/_react["default"].createElement("span", null, "All ", /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedNumber, {
      value: totalRecords
    }), " ", recordType, " in this search are selected.", /*#__PURE__*/_react["default"].createElement(_togaButton["default"], {
      appearance: "link",
      className: cx('clear-selection-in-dataset__button'),
      onClick: clearSelectionCallback
    }, "Clear selection"));
  } else if (!isAllDatasetSelected && selectedIds.length < pageSize) {
    // Some records are selected IN THIS PAGE
    content = /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedNumber, {
      value: selectedIds.length
    }), " ", recordType, " selected");
  } else {
    // All items in IN THIS PAGE are selected, offer select all dataset
    content = /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedNumber, {
      value: selectedIds.length
    }), " ", recordType, " are selected.", /*#__PURE__*/_react["default"].createElement(_togaButton["default"], {
      appearance: "link",
      className: cx('select-all-in-dataset__button'),
      onClick: selectAllDatasetCallback
    }, "Select all\xA0", /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedNumber, {
      value: totalRecords
    }), "\xA0", recordType !== undefined && recordType.toLowerCase()));
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: cx('table-container__selections-info')
  }, content);
};

SelectionIndicator.propTypes = {
  clearSelectionCallback: _propTypes["default"].func.isRequired,
  isAllDatasetSelected: _propTypes["default"].bool.isRequired,
  pageSize: _propTypes["default"].number.isRequired,
  recordType: _propTypes["default"].string.isRequired,
  selectAllDatasetCallback: _propTypes["default"].func,
  selectedIds: _propTypes["default"].array.isRequired,
  totalRecords: _propTypes["default"].number
};
SelectionIndicator.defaultProps = {
  selectAllDatasetCallback: null,
  totalRecords: null
};
var _default = SelectionIndicator;
exports["default"] = _default;